export const GET_SUBSCRIPTION_AGREEMENTS_SUCCESS = 'GET_SUBSCRIPTION_AGREEMENTS_SUCCESS';
export const SET_SUBSCRIPTION_AGREEMENTS_LOADING = 'SET_SUBSCRIPTION_AGREEMENTS_LOADING';
